import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CourseCardProps {
  title: string;
  image: string;
  date: string;
  duration: string;
  description: string;
  delay?: number;
  slug?: string;
}
export function CourseCard({
  title,
  image,
  date,
  duration,
  description,
  delay = 0,
  slug
}: CourseCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full border border-[#E0F0FA]" data-id="element-69">
      <div className="relative h-64 overflow-hidden" data-id="element-70">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-71" />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-[#5B9BD5] uppercase tracking-wider shadow-sm" data-id="element-72">
          Enrolling
        </div>
      </div>

      <div className="p-8 flex flex-col flex-grow" data-id="element-73">
        <h3 className="font-serif text-2xl font-bold text-[#3A5F7D] mb-3 group-hover:text-[#5B9BD5] transition-colors" data-id="element-74">
          {title}
        </h3>

        <div className="flex items-center gap-4 text-sm text-[#6B8FA8] mb-4" data-id="element-75">
          <div className="flex items-center gap-1.5" data-id="element-76">
            <Calendar className="w-4 h-4" data-id="element-77" />
            <span data-id="element-78">{date}</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-79">
            <Clock className="w-4 h-4" data-id="element-80" />
            <span data-id="element-81">{duration}</span>
          </div>
        </div>

        <p className="text-gray-600 mb-6 leading-relaxed flex-grow" data-id="element-82">
          {description}
        </p>

        <Link to={slug || '#'} className="flex items-center gap-2 text-[#5B9BD5] font-semibold group/btn self-start hover:text-[#4A7FB8] transition-colors" data-id="element-83">
          View Details
          <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" data-id="element-84" />
        </Link>
      </div>
    </motion.div>;
}